/**
 * Order-sale status vocabulary shared across the Sales surfaces.
 *
 * One source of truth for the OrderStatus -> StatusChip color family, so the
 * orders grid, the order form, and the order detail drawer render the same
 * status pill identically.
 *
 * Contains:
 * - ORDER_STATUS_COLOR — OrderStatus value -> StatusChip status family
 * - orderStatusColor   — (status) -> StatusChip status family, Draft fallback
 */

// StatusChip status family (cssTokens.js --status-*) per OrderStatus value.
export const ORDER_STATUS_COLOR = {
  New: 'info',
  Draft: 'neutral',
  Shipped: 'ok',
  'Billing - On Hold': 'warning',
  Complete: 'ok',
  Cancelled: 'bad',
  Deleted: 'neutral',
};

/**
 * Resolve the StatusChip color family for an OrderStatus value.
 * @param {string} status
 * @returns {string}
 */
export function orderStatusColor(status) {
  return ORDER_STATUS_COLOR[status] ?? ORDER_STATUS_COLOR.Draft;
}
